module.exports = __webpack_public_path__ + "media/images/new_landing/articles/learn-2-03e223b243fbe8d8c14dcd8df6e99a50.jpg";